export const balanceActions = {
  // returnReservedBalance
  5: 'Вернуть деньги на баланс',
  // takeReservedBalance
  6: 'Снять деньги с баланса',
};
